var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1753 0.816987C10.5421 0.0737414 11.6019 0.0737401 11.9688 0.816986L14.3661 5.67446C14.5117 5.9696 14.7933 6.17417 15.119 6.2215L20.4795 7.00043C21.2998 7.11961 21.6273 8.12759 21.0338 8.70612L17.1548 12.4871C16.9191 12.7169 16.8116 13.0479 16.8672 13.3723L17.7829 18.7111C17.923 19.528 17.0656 20.151 16.332 19.7653L11.5374 17.2446C11.246 17.0915 10.898 17.0915 10.6067 17.2446L5.81207 19.7653C5.07844 20.151 4.22101 19.528 4.36112 18.7111L5.27681 13.3723C5.33245 13.0479 5.2249 12.7169 4.98921 12.4871L1.11029 8.70612C0.516777 8.12759 0.844286 7.11961 1.66451 7.00043L7.02504 6.2215C7.35075 6.17417 7.63232 5.9696 7.77798 5.67446L10.1753 0.816987Z",
    fill: "#53507D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.e138b661f26f7045b5b50dd226811c44.svg";
export { ForwardRef as ReactComponent };